import React from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export const checkCell = ({ cell }) => (cell?.getValue() ? <CheckRoundedIcon color="success" /> : <CloseRoundedIcon color="error" />);
export const checkInfo = (value) => (value ? <CheckRoundedIcon color="success" /> : <CloseRoundedIcon color="error" />);
